import React, { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText } from '../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const AlertText = (props: AlertTextProps) => {
  const { children, style, ...restProps } = props;

  return (
    <BodyText sizeMatch={['14']} style={[styles.text, style]} {...restProps}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    flexShrink: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type AlertTextProps = ComponentProps<typeof BodyText>;
